
import React, { createContext, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { subtractDays } from '../utils/generalFunctions';

export const DateContext = createContext(null);

export const DateProvider = ({ children }) => {
    const [startDate, setStartDate] = useState(dayjs().startOf('day'));
    const [endDate, setEndDate] = useState(dayjs().endOf('day'));

    const initialEndDate = dayjs().endOf('day').toDate(); // para usar el mismo valor que el endDate inicial

    const [derivedDates, setDerivedDates] = useState(() => {
        const today = new Date(initialEndDate);
        const yesterday = subtractDays(1, today);
        const startActualWeek = subtractDays(6, today);
        const endActualWeek = today;
        const startPreviousWeek = subtractDays(13, today);
        const endPreviousWeek = subtractDays(7, today);

        const endActualMonth = today;
        const startActualMonth = subtractDays(29, endActualMonth);
        const startPreviousMonth = subtractDays(59, endActualMonth);
        const endPreviousMonth = subtractDays(30, endActualMonth, true);

        return {
            today,
            yesterday,
            startActualWeek,
            endActualWeek,
            startPreviousWeek,
            endPreviousWeek,
            startActualMonth,
            endActualMonth,
            startPreviousMonth,
            endPreviousMonth
        };
    });



    const updateDerivedDates = (baseDate = endDate) => {
        const today = new Date(baseDate);
        const yesterday = subtractDays(1, today);
        const startActualWeek = subtractDays(6, today);
        const endActualWeek = today;
        const startPreviousWeek = subtractDays(13, today);
        const endPreviousWeek = subtractDays(7, today);

        const endActualMonth = new Date(endDate);
        const startActualMonth = subtractDays(29, endActualMonth);
        const startPreviousMonth = subtractDays(59, endActualMonth);
        const endPreviousMonth = subtractDays(30, endActualMonth, true);

        setDerivedDates({
            today,
            yesterday,
            startActualWeek,
            endActualWeek,
            startPreviousWeek,
            endPreviousWeek,
            startActualMonth,
            endActualMonth,
            startPreviousMonth,
            endPreviousMonth
        });

    };

    const setCustomDerivedDates = (customDates) => {
        setDerivedDates(prev => ({...prev, ...customDates}));
    };

    useEffect(() => {
        updateDerivedDates();
    }, [startDate, endDate]);

    return (
        <DateContext.Provider
            value={{
                startDate,
                endDate,
                setStartDate,
                setEndDate,
                updateDerivedDates,
                setCustomDerivedDates,
                ...derivedDates
            }}
        >

            {children}
        </DateContext.Provider>
    );
};
